/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { TechniciansEfficientBranchReportResponseDto } from '../models/TechniciansEfficientBranchReportResponseDto';
import type { TechniciansEfficientReportResponseDtoPagedListData } from '../models/TechniciansEfficientReportResponseDtoPagedListData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TechniciansEfficientReportService {

  /**
   * @param employerName 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param paginationSkipPagination Пропустить пагинацию
   * @param paginationPage Страница
   * @param paginationMaxCount Максимально количество записей на странице
   * @param from 
   * @param to 
   * @returns TechniciansEfficientReportResponseDtoPagedListData Success
   * @throws ApiError
   */
  public static getTechniciansEfficientReport(
employerName?: string,
branch?: BranchType,
paginationSkipPagination?: boolean,
paginationPage?: number,
paginationMaxCount?: number,
from?: string,
to?: string,
): CancelablePromise<TechniciansEfficientReportResponseDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technicians-efficient-report',
      query: {
        'EmployerName': employerName,
        'Branch': branch,
        'Pagination.SkipPagination': paginationSkipPagination,
        'Pagination.Page': paginationPage,
        'Pagination.MaxCount': paginationMaxCount,
        'From': from,
        'To': to,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param from 
   * @param to 
   * @returns TechniciansEfficientBranchReportResponseDto Success
   * @throws ApiError
   */
  public static getTechniciansEfficientReportBranches(
from?: string,
to?: string,
): CancelablePromise<TechniciansEfficientBranchReportResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technicians-efficient-report/branches',
      query: {
        'From': from,
        'To': to,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param employerName 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param paginationSkipPagination Пропустить пагинацию
   * @param paginationPage Страница
   * @param paginationMaxCount Максимально количество записей на странице
   * @param from 
   * @param to 
   * @returns any Success
   * @throws ApiError
   */
  public static postTechniciansEfficientReportSaveBonus(
employerName?: string,
branch?: BranchType,
paginationSkipPagination?: boolean,
paginationPage?: number,
paginationMaxCount?: number,
from?: string,
to?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technicians-efficient-report/save-bonus',
      query: {
        'EmployerName': employerName,
        'Branch': branch,
        'Pagination.SkipPagination': paginationSkipPagination,
        'Pagination.Page': paginationPage,
        'Pagination.MaxCount': paginationMaxCount,
        'From': from,
        'To': to,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

}
